import { RouteConfig } from 'vue-router';

export function templateNameRoute(namePrefix: string): RouteConfig {
  return {
    path: 'name',
    name: namePrefix + 'Name',
    component: () => import(/* webpackChunkName: "TemplateName" */ '@/views/mainRoute/template/steps/TemplateName.vue'),
    meta: { title: 'Nazwa' }
  };
}
